import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import Guid from "./../../factories/guid";
import template from "./../templates/finito-upload-badge.html";
import dialogTemplate from "./../templates/finito-upload-dialog.html";
import "./../../bindings/bao-upload";

export class FinitoUploadBadge {
    ShowAll = ko.observable(false);
    Items: any = ko.observableArray();
    UploadUrl = ko.observable();
    LinkUrl = ko.observable();
    MultiUpload = ko.observable(true);
    AddAbsolutePath = ko.observable(true);
    IsLoading = ko.observable();
    FileNames = ko.observableArray([]);
    optionsText = '';
    optionsValue = '';
    ReadOnly = ko.observable(false);
    itemDeleted = function () { };
    itemAdded = function () { };
    upload = function () { };
    removeItem: any = function () {
        // wird via params überschrieben
        throw "finito-upload-badge: param.deleteItem must be set.";
    };

    
    // binding options for baoUplaod
    BaoUploadOptions = {
        Upload: 'upload',
        MultiUpload: this.MultiUpload,
        FileNames: this.FileNames,
        Url: this.UploadUrl,
        AddAbsolutePath: false
    };

    openFile = function (badge) {
        window.open(this.LinkUrl() + '/' + badge[this.optionsValue]());
    };

    showUploadDialog = function () {
        var dialog = new BaoDialog(Bao.Session.ApplicationName);
        dialog.Buttons([
            {
                Title: Bao.Session.GetMessage("msgOk"),
                Click: this.UploadDialogButtonOkClicked.bind(dialog, this),
                Enabled: ko.observable(true)
            },
            {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: function () {
                    dialog.DialogResult(false);
                    dialog.Close();
                },
                Enabled: ko.observable(true)
            }
        ]);
        dialog.Template(dialogTemplate);
        dialog.ViewModel(this);
        dialog.Open();
    };

    UploadDialogButtonOkClicked = function (self) {
        self.IsLoading(true);
        self.upload().then(function () {
            var dialog = this;
            if (ko.unwrap(self.MultiUpload)) {
                self.itemAdded();
            }
            dialog.DialogResult(true);
            self.IsLoading(false);
            dialog.Close();
        }.bind(this));
    };

    setShowAll() {
        this.ShowAll(!this.ShowAll.peek());
    };
    constructor(params) {
        if (params) {
            if (params.items) {
                if (ko.isObservable(params.items)) {
                    this.Items = params.items;
                } else {
                    this.Items(params.items);
                }
            }
            if (params.optionsText) {
                this.optionsText = ko.unwrap(params.optionsText);
            }
            if (params.optionsValue) {
                this.optionsValue = ko.unwrap(params.optionsValue);
            }
            if ($.isFunction(params.deleteItem)) {
                this.removeItem = function (item, e) {
                    e.stopPropagation();
                    params.deleteItem(item, e);
                };
            }
            if (params.UploadUrl) {
                if (this.AddAbsolutePath()) {
                    this.UploadUrl(window.absolutePath + ko.unwrap(params.UploadUrl))
                } else {
                    this.UploadUrl(ko.unwrap(params.UploadUrl));
                }
            }
            if (params.LinkUrl) {
                if (this.AddAbsolutePath()) {
                    this.LinkUrl(window.absolutePath + ko.unwrap(params.LinkUrl))
                } else {
                    this.LinkUrl(ko.unwrap(params.LinkUrl));
                }
            }
            if (params.IsLoading) {
                this.IsLoading = params.IsLoading;
            }
            if (params.vm && params.showDialog) {
                params.vm[params.showDialog] = function () {
                    this.showUploadDialog();
                }.bind(this);
            }
            if ($.isFunction(params.itemAdded)) {
                this.itemAdded = params.itemAdded;
            }
            if (ko.isObservable(params.ReadOnly)) {
                this.ReadOnly = params.ReadOnly;
            }

        }
        // Top 10/Alle anzeigen
        this.Items.Badged = ko.pureComputed(function () {
            var items = this.Items();
            if (this.ShowAll()) {
                return items;
            } else {
                return items.slice(0, 9);
            }
        }.bind(this));
    }

}
export default {
    viewModel: FinitoUploadBadge,
    template: template
};